
const HelpButton = () => {
  return (
    <a
      className="align-self-start d-flex  align-items-center"
      href="mailto:team@zerobees.com"

    >
      Need help?
      <strong className="ml-1">Contact us</strong>
    </a>
  );
};

export default HelpButton;
